// import logo from "./logo.svg";
import "./App.css";

import idLocale from "./assets/locale/id.json";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { addLocale } from "primereact/api";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useContext, Suspense } from "react";
import UiContext from "./store/ui-context";

import ErrorPage from "./pages/error/ErrorPage";
import LoginPage from "./pages/login/LoginPage";

import LayoutDashboardPage from "./pages/LayoutPage";
import LayoutDashboardUserPage from "./pages/dashboard-user/LayoutDashboardUserPage";

//import protector
import ProtectedRoute from "./pages/protected/ProtectedRoute";
import ProtectedRouteUser from "./pages/protected/ProtectedRouteUser";

//import admin page
import HomePage from "./pages/dashboard/home-page";
import SignUpPage from "./pages/sign-up/SignUpPage";

import UserHomePage from "./pages/dashboard-user/default/UserHomePage";
import TujuanMasterPage from "./pages/master/tujuan/TujuanPage";
import KendaraanGrupMasterPage from "./pages/master/kendaraan_grup/KendaraanGrupPage";
import KendaraanJenisMasterPage from "./pages/master/kendaraan_jenis/KendaraanJenisPage";
import JenisMobilMasterPage from "./pages/master/jenis-mobil/jenis-mobil-page";
import KendaraanPemakaianMasterPage from "./pages/master/kendaraan_pemakaian/KendaraanPemakaianPage";
import KendaraanMasterPage from "./pages/master/kendaraan/KendaraanPage";
import KaryawanMasterPage from "./pages/master/karyawan/KaryawanPage";
import TraceBarcodePage from "./pages/dashboard/default/trace-barcode/TraceBarcodePage";
import CekKeluarMasukEditorPage from "./pages/cek-keluar-masuk/CekKeluarMasukEditorPage";
import CekKeluarMasukArsipPage from "./pages/cek-keluar-masuk/CekKeluarMasukArsipPage";
import KendaraanRetribusiPage from "./pages/retribusi/KendaraanRetribusiPage";
import ProblemKendaraanPage from "./pages/problem/problem_kendaraan/ProblemKendaraanPage";
import PengecekanMobilOptionPage from "./pages/master/pengecekan_mobil_options/PengecekanMobilOptionPage";
import JadwalMobil from "./pages/jadwal-mobil/jadwal-mobil";
import TrailerPage from "./pages/master/trailer/TrailerPage";
import CekKeluarMasukTradoArsipPage from "./pages/cek-keluar-masuk-trado/CekKeluarMasukTradoArsipPage";
import CekKeluarMasukTradoEditorPage from "./pages/cek-keluar-masuk-trado/CekKeluarMasukTradoEditorPage";
import ProblemKendaraanTradoPage from "./pages/problem/problem_kendaraan_trado/ProblemKendaraanTradoPage";
import JadwalMobilTrado from "./pages/jadwal-mobil-trado/jadwal-mobil-trado";
import LaporanMasalahMobil from "./pages/laporan/masalah-mobil/laporan-masalah-mobil";
import LaporanMasalahMobilPage from "./pages/laporan/masalah-mobil/laporan-masalah-mobil";
import LaporanMainPage from "./pages/laporan/laporan-main-page";
import LaporanMasalahDutroPage from "./pages/laporan/masalah-dutro/laporan-masalah-dutro";
import LaporanMasalahTradoPage from "./pages/laporan/masalah-trado/laporan-masalah-trado";
import LaporanMasalahTrailerPage from "./pages/laporan/masalah-trailer/laporan-masalah-trailer";
import PengisianMinyakPage from "./pages/pengisian-minyak/pengisian-minyak-page";
import PermintaanMobilPage from "./pages/permintaan-mobil/PermintaanMobilPage";
import LaporanMasalahMobilPerUnitPage from "./pages/laporan/masalah-mobil-per-unit/laporan-masalah-mobil-per-unit";
import LaporanMasalahDutroPerUnitPage from "./pages/laporan/masalah-dutro-per-unit/laporan-masalah-dutro-per-unit";
import LaporanMasalahTradoPerUnitPage from "./pages/laporan/masalah-trado-per-unit/laporan-masalah-trado-per-unit";
import LaporanMasalahTrailerPerUnitPage from "./pages/laporan/masalah-trailer-per-unit/laporan-masalah-trailer-per-unit";
import ServiceMasterPage from "./pages/master/service/service-master-page";
import KendaraanServiceMasterPage from "./pages/master/kendaraan-service/kendaraan-service-master-page";
import ServiceKendaraanPage from "./pages/service-kendaraan/ServiceKendaraanPage";
import LaporanServiceMobilByKMPage from "./pages/laporan/service-mobil-by-km/laporan-service-mobil-by-km";
import LaporanServiceTradoByKMPage from "./pages/laporan/service-trado-by-km/laporan-service-trado-by-km";
import LaporanServiceDutroByKMPage from "./pages/laporan/service-dutro-by-km/laporan-service-dutro-by-km";
import LaporanHistoryServiceMobilPage from "./pages/laporan/history-service-mobil/laporan-history-service-mobil";
import LaporanHistoryServiceDutroPage from "./pages/laporan/history-service-dutro/laporan-history-service-dutro";
import LaporanHistoryServiceTradoPage from "./pages/laporan/history-service-trado/laporan-history-service-trado";
import JenisMinyakMasterPage from "./pages/master/jenis-minyak/jenis-minyak-page";
import DepartmentMasterPage from "./pages/master/department/department-master-page";
import AlatBeratMasterPage from "./pages/master/alat-berat/alat-berat-master-page";
import JabatanMasterPage from "./pages/master/jabatan/jabatan-master-page";
import PermintaanMinyakPage from "./pages/permintaan-minyak/PermintaanMinyakPage";
import PermintaanMinyakEditorPage from "./pages/permintaan-minyak/PermintaanMinyakEditorPage";
import KartuStokMinyakPage from "./pages/kartu-stok-minyak/KartuStokMinyakPage";
import WarningServicePage from "./pages/warning-service/WarningServicePage";
import LaporanPengisianMinyakPerUnitPage from "./pages/laporan/pengisian-minyak-per-unit/laporan-pengisian-minyak-per-unit-page";
import LaporanPengisianMinyakPerJenisPage from "./pages/laporan/pengisian-minyak-per-jenis/laporan-pengisian-minyak-per-jenis-page";
import AuditKendaraanEditorPage from "./pages/audit-kendaraan/AuditKendaraanEditorPage";
import AuditKendaraanArsipPage from "./pages/audit-kendaraan/AuditKendaraanArsipPage";
import AuditKendaraanTradoArsipPage from "./pages/audit-kendaraan/AuditKendaraanTradoArsipPage";
import AuditKendaraanTradoEditorPage from "./pages/audit-kendaraan/AuditKendaraanTradoEditorPage";
import VerifyPage from "./pages/master/verify-settings/VerifyPage";

// import reports

function App() {
  const uiContext = useContext(UiContext);

  const toastRef = useRef();

  useEffect(() => {
    uiContext.setToastRef(toastRef);
  }, [toastRef]);

  addLocale("id", idLocale.id);

  const getBaseName = () => {
    const reactAppPathV2 = process.env.REACT_APP_PATH + "/frontend/build_v2";
    if (window.location.pathname.includes(reactAppPathV2)) {
      return reactAppPathV2;
    } else {
      return "";
    }
  };

  const MyRouter = (
    <BrowserRouter basename={getBaseName()}>
      <Routes>
        <Route path="/login" element={<LoginPage />}></Route>
        <Route path="/sign-up" element={<SignUpPage />}></Route>
        <Route
          // index
          path="/"
          element={
            <ProtectedRoute>
              <LayoutDashboardPage />
            </ProtectedRoute>
          }
        >
          <Route index element={<HomePage />}></Route>
          <Route path="trace-barcode" element={<TraceBarcodePage />}></Route>
          <Route path="transaksi">
            <Route
              path="permintaan-mobil"
              element={<PermintaanMobilPage />}
            ></Route>
            <Route path="cek-keluar-masuk">
              <Route index element={<CekKeluarMasukArsipPage />} />
              <Route path="berangkat">
                <Route path=":id" element={<CekKeluarMasukEditorPage />} />
              </Route>
              <Route path="kembali">
                <Route path=":id" element={<CekKeluarMasukEditorPage />} />
              </Route>
            </Route>
            <Route path="cek-keluar-masuk-trado">
              <Route index element={<CekKeluarMasukTradoArsipPage />} />
              <Route path="berangkat">
                <Route path=":id" element={<CekKeluarMasukTradoEditorPage />} />
              </Route>
              <Route path="kembali">
                <Route path=":id" element={<CekKeluarMasukTradoEditorPage />} />
              </Route>
            </Route>
            <Route
              path="kendaraan-retribusi"
              element={<KendaraanRetribusiPage />}
            />
            <Route path="jadwal-mobil" element={<JadwalMobil />}></Route>
            <Route path="jadwal-trado" element={<JadwalMobilTrado />}></Route>
            <Route
              path="kendaraan-pengisian-minyak"
              element={<PengisianMinyakPage />}
            ></Route>
            <Route
              path="service-kendaraan"
              element={<ServiceKendaraanPage />}
            ></Route>
            <Route path="permintaan-minyak">
              <Route index element={<PermintaanMinyakPage />} />
              <Route path="edit">
                <Route path=":id" element={<PermintaanMinyakEditorPage />} />
              </Route>
            </Route>
            <Route
              path="kartu-stok-minyak"
              element={<KartuStokMinyakPage />}
            ></Route>
          </Route>
          <Route path="audit">
            <Route path="audit-kendaraan">
              <Route index element={<AuditKendaraanArsipPage />} />
              <Route path="edit">
                <Route path=":id" element={<AuditKendaraanEditorPage />} />
              </Route>
            </Route>
            <Route path="audit-kendaraan-trado">
              <Route index element={<AuditKendaraanTradoArsipPage />} />
              <Route path="edit">
                <Route path=":id" element={<AuditKendaraanTradoEditorPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="problem">
            <Route
              path="problem-kendaraan"
              element={<ProblemKendaraanPage />}
            ></Route>
            <Route
              path="problem-kendaraan-trado"
              element={<ProblemKendaraanTradoPage />}
            ></Route>
          </Route>
          <Route path="service">
            <Route path="warning-service" element={<WarningServicePage />} />
          </Route>
          <Route path="laporan">
            <Route index element={<LaporanMainPage />} />
            <Route
              path="pengisian-minyak-per-unit"
              element={<LaporanPengisianMinyakPerUnitPage />}
            />
            <Route
              path="pengisian-minyak-per-jenis"
              element={<LaporanPengisianMinyakPerJenisPage />}
            />
            <Route path="masalah-mobil" element={<LaporanMasalahMobilPage />} />
            <Route
              path="masalah-mobil-per-unit"
              element={<LaporanMasalahMobilPerUnitPage />}
            />
            <Route path="masalah-dutro" element={<LaporanMasalahDutroPage />} />
            <Route
              path="masalah-dutro-per-unit"
              element={<LaporanMasalahDutroPerUnitPage />}
            />
            <Route path="masalah-trado" element={<LaporanMasalahTradoPage />} />
            <Route
              path="masalah-trado-per-unit"
              element={<LaporanMasalahTradoPerUnitPage />}
            />
            <Route
              path="masalah-trailer"
              element={<LaporanMasalahTrailerPage />}
            />
            <Route
              path="masalah-trailer-per-unit"
              element={<LaporanMasalahTrailerPerUnitPage />}
            />
            <Route
              path="service-mobil-by-km"
              element={<LaporanServiceMobilByKMPage />}
            />
            <Route
              path="service-dutro-by-km"
              element={<LaporanServiceDutroByKMPage />}
            />
            <Route
              path="service-trado-by-km"
              element={<LaporanServiceTradoByKMPage />}
            />
            <Route
              path="history-service-mobil"
              element={<LaporanHistoryServiceMobilPage />}
            />
            <Route
              path="history-service-dutro"
              element={<LaporanHistoryServiceDutroPage />}
            />
            <Route
              path="history-service-trado"
              element={<LaporanHistoryServiceTradoPage />}
            />
          </Route>
          <Route path="master">
            <Route path="tujuan" element={<TujuanMasterPage />} />
            <Route path="kendaraan" element={<KendaraanMasterPage />} />
            <Route path="trailer" element={<TrailerPage />} />
            <Route
              path="kendaraan_grup"
              element={<KendaraanGrupMasterPage />}
            />
            <Route
              path="kendaraan_jenis"
              element={<KendaraanJenisMasterPage />}
            />
            <Route
              path="kendaraan_pemakaian"
              element={<KendaraanPemakaianMasterPage />}
            />
            <Route
              path="pengecekan_mobil_options"
              element={<PengecekanMobilOptionPage />}
            />
            <Route path="service" element={<ServiceMasterPage />} />
            <Route
              path="kendaraan-service"
              element={<KendaraanServiceMasterPage />}
            />
            <Route path="jenis-minyak" element={<JenisMinyakMasterPage />} />
            <Route path="department" element={<DepartmentMasterPage />} />
            <Route path="alat-berat" element={<AlatBeratMasterPage />} />
            <Route path="jabatan" element={<JabatanMasterPage />} />
            <Route path="jenis-mobil" element={<JenisMobilMasterPage />} />
            <Route path="karyawan" element={<KaryawanMasterPage />} />
            <Route path="verify" element={<VerifyPage />} />
          </Route>
          <Route path="report"></Route>
          <Route path="setting"></Route>
        </Route>
        <Route
          // index
          path="user"
          element={
            <ProtectedRouteUser>
              <LayoutDashboardUserPage />
            </ProtectedRouteUser>
          }
        >
          <Route path="main" element={<UserHomePage />}></Route>
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );

  return (
    <>
      <Toast ref={toastRef} />
      {!toastRef.current && (
        <div className="col-center-center py-4">
          <h1> Initializing application ... </h1>{" "}
        </div>
      )}
      {toastRef.current && MyRouter}
    </>
  );
}

export default App;
